(function(){
    'use strict';
    angular
        .module('MW.Influencers.FilterFactory', [
            'ngMaterial',
            'mwAppComponents',
            'MW.ContactManager.SelectionFactory'
        ])
        .factory('FilterFactory', [
            '$mdDialog',
            '$filter',
            '$translate',
            '$q',
            'FilterSelectionFactory',
            function($mdDialog, $filter, $translate, $q, FilterSelectionFactory) {
                function FilterFactory(name, triggerSearchFunction) {
                    this.$mdDialog = $mdDialog;
                    this.$translate = $translate;

                    this.filterName = name;
                    this.currentOptions = [];

                    this.callback = triggerSearchFunction;

                    this.selectionFactory = new FilterSelectionFactory(name);
                    this.searchInProgress = null;
                }

                FilterFactory.prototype.showModal = function showModal(event) {
                    this.selectionFactory.snapshotState();

                    // this = mwModal
                    function MiniModalController() {

                        if(this.searchInProgress) {
                            this.loading = true;
                            this.filteredOptions = [];
                            this.searchInProgress.promise.then(function(results) {
                                this.filteredOptions = results;
                                this.loading = false;
                            }.bind(this));
                        } else {
                            this.filteredOptions = this.SelectionFactory.currentOptions;
                        }

                        if (this.filterName === 'icm-search__location-filter--title') {
                           // skip the country page if there is only 1 country entitlement
                           if (this.filteredOptions.length === 1) {
                               this.SelectionFactory.openChild(this.filteredOptions[0]);
                               this.filterName = this.filteredOptions[0].display;
                               this.filteredOptions = this.filteredOptions[0].children;
                               this.SelectionFactory.parent.name = null;
                           }
                       }

                        this.hasChildren = (this.SelectionFactory.parent && this.SelectionFactory.parent.children.length ? true : false);
                        this.updateCount();

                        this.onFocus = function onFocus() {
                            angular.element('i.material-icons > span').addClass('active');
                        }.bind(this);

                        this.onBlur = function onBlur() {
                            if (this.filterText.length === 0) {
                                angular.element('i.material-icons > span').removeClass('active');
                            }
                        }.bind(this);

                        this.shouldDisplayCount = function shouldDisplayCount(){
                          return !(this.SelectionFactory.currentOptions.length > 0 && this.SelectionFactory.currentOptions[0].level && this.SelectionFactory.currentOptions[0].level === 'country');
                        };

                        this.clearPage = function clearPage() {
                            this.SelectionFactory.deselectAll();
                            this.updateCount();
                        };

                        this.bubbleSelected = function bubbleSelected() {
                            var selected = [],
                                notSelected = [];

                            this.filteredOptions.forEach(function(option) {
                                if(this.SelectionFactory.isSelected(option) || this.SelectionFactory.isPartiallySelected(option)) {
                                    selected.push(option);
                                } else {
                                    notSelected.push(option);
                                }
                            }, this);

                            this.filteredOptions = selected.concat(notSelected);
                            this.currentSelectedCount = selected.length;
                        };

                        this.filterCurrentOptions = function filterCurrentOptions(dataRetrievalPromise) {
                            // in some cases we need to retrieve data, so wait until its ready before acting on it
                            $q.when(dataRetrievalPromise, function() {
                                if (this.filterText.length > 1) {
                                    this.filteredOptions = this.$filter('filter')(this.SelectionFactory.currentOptions, this.nameMatchPredicate);

                                    if (this.filteredOptions.length === 1) {
                                        this.filteredCount = this.$translate.instant('icm-search__mini-mod__result-count-label');
                                    } else {
                                        this.filteredCount = this.$translate.instant('icm-search__mini-mod__plural-results-count-label', {count: this.filteredOptions.length});
                                    }
                                } else if(this.filterText.length < 1) {
                                    this.filteredOptions = _.sortBy(this.SelectionFactory.currentOptions, 'name');
                                    this.updateCount();
                                }

                                this.hasChildren = this.filteredOptions.length > 0;

                                this.bubbleSelected();
                            }.bind(this));
                        };

                        this.nameMatchPredicate = function nameMatchPredicate(element) {
                            var foundMatch = false;

                            if (element && element.display && element.display.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0) {
                                foundMatch = true;
                            } else if (element.children) {
                                foundMatch = element.children.some(function (child) {
                                    return child.display.toLowerCase().indexOf(this.filterText.toLowerCase()) >= 0;
                                }.bind(this));
                            }

                            return foundMatch;
                        }.bind(this);

                        this.scrollToTop = function scrollToTop() {
                            $('md-virtual-repeat-scroller').scrollTop(0);
                        };

                        this.toggle = function toggle(item){
                            this.SelectionFactory.toggle(item);
                            this.updateCount();
                        };

                        this.radioButtonChange = function radioButtonChange(item) {
                            this.SelectionFactory.displayState.selected = {};
                            this.SelectionFactory.toggle(item);
                        };

                        this.getTooltipMessage = function getTooltipMessage(itemDisplay, count) {
                            var tooltip = this.$translate.instant('icm-search__mini-mod--option-match-tooltip', {option: _.unescape(itemDisplay), count: count});

                            return _.unescape(tooltip);
                        };

                        this.bubbleSelected();
                    }

                    MiniModalController.prototype.updateCount = function updateCount(){
                        this.filteredCount = this.$translate.instant('icm-search__mini-mod__selected-count-label', {count: this.SelectionFactory.selectedCurrentOptionCount()});
                    };

                    this.$mdDialog.show(
                        this.$mdDialog.mwMiniModal({
                            multiple: true,
                            locals: {
                                SelectionFactory: this.selectionFactory,
                                filteredOptions: this.filteredOptions,
                                searchInProgress: this.searchInProgress,
                                filteredCount: this.filteredCount,
                                currentSelection: this.selectionFactory.displayState.radioSelection,
                                filterText: '',
                                filterName: this.filterName,
                                hasChildren: false,
                                $mdDialog: $mdDialog,
                                $filter: $filter,
                                $translate: $translate,
                                onlyLeafNodeSelection: this.onlyLeafNodeSelection || false,
                                selectedCount: function() {
                                    return this.currentSelectedCount;
                                },
                                openChild: function openChild(item, callback) {
                                    var _this = this;

                                    _this.loading = true;
                                    return _this.SelectionFactory.openChild(item, callback).finally(function() {
                                        _this.loading = false;
                                    });
                                }
                            },
                            controller: MiniModalController,
                            templateUrl: 'icm-web/views/filter_modals/filter_mini_modal',
                            controllerAs: '$ctrl'
                        }).targetEvent(event)
                    ).then(
                        function okHandler() {
                            this.selectionFactory.resetDepth();
                            this.callback();
                        }.bind(this),
                        function cancelHandler() {
                            this.selectionFactory.rollback();
                            this.selectionFactory.resetDepth();
                        }.bind(this)
                    ).catch(function () {});
                };

                // called from expansion panel
                FilterFactory.prototype.selectionChanged = function selectionChanged(option, updateAncestors) {
                    this.selectionFactory.toggle(option, updateAncestors);
                    this.callback();
                };

                FilterFactory.prototype.clearAll = function clearAll() {
                    this.selectionFactory.reset();
                };

                // Allow minimodal to pupulate new data after its rendered
                FilterFactory.prototype.waitOnSearch = function waitOnSearch() {
                    this.searchInProgress = $q.defer();
                };

                FilterFactory.prototype.filterOptions = function filterOptions(searchText) {
                    var currentFilters = this.selectionFactory.getSelection();

                    return this.currentOptions
                        .filter(function(option) {
                            return typeof currentFilters[option.key] === 'undefined';
                        }.bind(this))
                        .filter(function(option) {
                            return option.display.match(new RegExp(searchText, 'i'));
                        });
                };

                FilterFactory.prototype.filterRelevantOptions = function filterRelevantOptions(searchText) {
                    return this.filterOptions(searchText)
                        .filter(function(option) {
                            return !option.nonRelevant;
                        });
                };

                FilterFactory.prototype.updateOptions = function updateOptions(options) {
                    if(this.allOptionsObject) {
                        options = this.insertNonRelevantOptions(options);
                    }
                    this.currentOptions = options;

                    this.currentOptions.forEach(function(currentOption) {
                        if(!currentOption.name) {
                            currentOption.name = currentOption.key;
                        }
                    });

                    // if were waiting on a search, we are now satisfied
                    if(this.searchInProgress) {
                        this.searchInProgress.resolve(this.currentOptions);
                        this.searchInProgress = null;
                    }

                    if(this.filterName === 'icm-search__location-filter--title') {
                        this.selectionFactory.updateCurrentOptions(options, true);
                    } else {
                        this.selectionFactory.updateCurrentOptions(options);
                    }

                };

                FilterFactory.prototype.insertNonRelevantOptions = function(relevantOptions) {
                    var relevantOptionsObject = {},
                        tempList = angular.copy(this.allOptionsObject),
                        finalList = [];

                    // make a hashmap for relevantOptions, already have one for all options
                    relevantOptions.forEach(function(option) {
                        relevantOptionsObject[option.key] = option;
                        if(option.children) {
                            option.children.forEach(function(childOption) {
                                relevantOptionsObject[childOption.key + childOption.parentKey] = childOption;  // child ID's are not always unique
                            }.bind(this));
                        }
                    });

                    // isolate the non relevant options
                    Object.keys(tempList).forEach(function(optionKey) {
                        if(relevantOptionsObject[optionKey]) {
                            // grab the count from the relevant option
                            tempList[optionKey].count = relevantOptionsObject[optionKey].count;

                            if(relevantOptionsObject && relevantOptionsObject[optionKey] && relevantOptionsObject[optionKey].name) {
                                tempList[optionKey].name = relevantOptionsObject[optionKey].name;
                            }

                            if(relevantOptionsObject && relevantOptionsObject[optionKey] && relevantOptionsObject[optionKey].display) {
                                tempList[optionKey].display = relevantOptionsObject[optionKey].display;
                            }

                            if(tempList[optionKey].children) {
                                tempList[optionKey].children.forEach(function(child) {
                                    var relevantOption = relevantOptionsObject[child.key + child.parentKey];

                                    child.count = relevantOption ? relevantOption.count : 0;

                                    if(relevantOption && relevantOption.name) {
                                        child.name = relevantOption.name;
                                    }

                                    if(relevantOption && relevantOption.display) {
                                        child.display = relevantOption.display;
                                    }
                                    else if (child.name && !child.display) {
                                        child.display = 'icm-search__filter--' + child.name.toLowerCase().replace(new RegExp(' ', 'g'), '-');
                                    }

                                    if(!relevantOption) {
                                        child.nonRelevant = true;
                                        child.count = 0;
                                    }
                                }.bind(this));
                            }
                        } else {
                            tempList[optionKey].nonRelevant = true;
                            tempList[optionKey].count = 0;
                        }
                    }.bind(this));

                    // convert back to array
                    Object.keys(tempList).forEach(function(tempKey) {
                        finalList.push(tempList[tempKey]);
                    });

                    return finalList;
                };

                FilterFactory.prototype.setAllOptions = function setAllOptions(options) {
                    var optionsObject = {};
                    options.forEach(function(option) {
                        optionsObject[option.key] = option;
                    });
                    this.allOptionsObject = optionsObject;

                };

                FilterFactory.prototype.getSelectedCount = function getSelectedCount() {
                    return Object.keys(this.selectionFactory.displayState.selected).length;
                };

                FilterFactory.prototype.getSelectedValues = function getSelectedValues() {
                    return Object.keys(this.selectionFactory.displayState.selected);
                };

                return FilterFactory;
            }
        ])
        .factory('BeatFilter', [
            'FilterFactory',
            'BeatSelectionFactory',
            function (FilterFactory, BeatSelectionFactory) {
                function BeatFilter(name, triggerSearchFunction) {
                    FilterFactory.call(this, name, triggerSearchFunction);

                    this.selectionFactory = new BeatSelectionFactory(name);

                    this.getSelectedCount = function getSelectedCount() {
                        return this.selectionFactory.getSelectedChildren().length;
                    };

                    this.filterOptions = function filterBeats(searchText, allBeats) {
                        var currentFilters = this.selectionFactory.getSelection();
                        return allBeats
                            .filter(function(option) {
                                return typeof currentFilters[this.selectionFactory.keyScheme(option)] === 'undefined';
                            }.bind(this))
                            .map(function(option) {
                                if (option.parentKey && (option.display.indexOf(option.parentDisplay) < 0)) {
                                    option.display = option.display + ', ' + option.parentDisplay;
                                }

                                return option;
                            })
                            .filter(function(option) {
                                return option.display.match(new RegExp(searchText, 'i'));
                            });
                    };

                    this.selectionFactory.hasChildren = function hasChildren(option, filterText) {
                        if(!option.children || !option.children.length) {
                            return false;
                        }
                        if(filterText && filterText.length) {
                            return option.children.filter(function(child) {
                                return child.display.toLowerCase().includes(filterText.toLowerCase());
                            }).length;
                        } else {
                            return true;
                        }
                    };
                }

                BeatFilter.prototype = Object.create(FilterFactory.prototype);

                return BeatFilter;
            }
        ])
        .factory('LocationFilter', [
            'FilterFactory',
            'LocationSelectionFactory',
            function (FilterFactory, LocationSelectionFactory) {
                function LocationFilter(name, triggerSearchFunction) {
                    FilterFactory.call(this, name, triggerSearchFunction);

                    this.selectionFactory = new LocationSelectionFactory(name);

                    this.getSelectedCount = function getSelectedCount() {
                        return this.selectionFactory.getQuerySelectionCount();
                    };

                    this.updateQuery = function updateQuery(searchText, filters, searchType, chips, dateRangeDays, language){
                        this.selectionFactory.updateQuery(searchText, filters, searchType, chips, dateRangeDays, language);
                    };
                }

                LocationFilter.prototype = Object.create(FilterFactory.prototype);

                return LocationFilter;
            }
        ])
        .factory('SourceFilter', [
            'FilterFactory',
            'FilterSelectionFactory',
            function (FilterFactory, FilterSelectionFactory) {
                function SourceFilter(name, triggerSearchFunction) {
                    FilterFactory.call(this, name, triggerSearchFunction);

                    this.selectionFactory = new FilterSelectionFactory(name);

                    this.showModal = function showModal(event) {
                        function MiniModalController() {
                            // convert the object to an array list, so we can properly use ngRepeat & orderBy
                            this.filteredOptions = Object.keys(this.SelectionFactory.displayState.selected).map(function(key) {
                                return this.SelectionFactory.displayState.selected[key];
                            }, this);

                            this.isSelected = function isSelected(item) {
                                return (this.filteredIds.indexOf(item.key) > -1);
                            };

                            this.getSelectedCount = function getSelectedCount() {
                                return this.filteredIds.length;
                            };

                            this.updateCount = function updateCount() {
                                this.filteredCount = this.$translate.instant('icm-search__mini-mod__selected-count-label', {count: this.getSelectedCount()});
                            };

                            this.toggle = function toggle(item) {
                                var index = this.filteredIds.indexOf(item.key);
                                if (index >= 0) {
                                    this.filteredIds.splice(index, 1);
                                } else {
                                    this.filteredIds.push(item.key);
                                }

                                this.updateCount();
                            };

                            this.clearAll = function clearAll() {
                                this.filteredIds = [];
                                this.updateCount();
                            };

                            this.updateCount();
                        }

                        this.$mdDialog.show(
                            this.$mdDialog.mwMiniModal({
                                locals: {
                                    SelectionFactory: this.selectionFactory,
                                    filteredOptions: this.filteredOptions,
                                    filteredIds: this.selectionFactory.getSelectedValues(),
                                    filteredCount: this.getSelectedCount(),
                                    filterName: 'icm-search__sourceName-filter--title',
                                    $mdDialog: this.$mdDialog,
                                    $translate: this.$translate
                                },
                                controller: MiniModalController,
                                templateUrl: 'icm-web/views/filter_modals/source_name_mini_modal',
                                controllerAs: '$ctrl'
                            }).targetEvent(event)
                        ).then(
                            function okHandler(selectedIds) {
                                if (selectedIds.length < this.getSelectedCount()) {
                                    var temp = {};
                                    selectedIds.forEach(function(selectedId) {
                                        temp[selectedId] = this.selectionFactory.displayState.selected[selectedId];
                                    }.bind(this));
                                    this.selectionFactory.displayState.selected = temp;
                                    this.selectionFactory.resetDepth();
                                    this.callback();
                                }
                            }.bind(this)
                        ).catch(function () {});
                    };
                }

                SourceFilter.prototype = Object.create(FilterFactory.prototype);

                return SourceFilter;
            }
        ])
        .factory('EmailFilter', [
            'FilterFactory',
            'FilterSelectionFactory',
            function (FilterFactory) {
                function EmailFilter(name, triggerSearchFunction) {
                    var _this = this;
                    FilterFactory.call(this, name, triggerSearchFunction);

                    this.selectedEmails = [];

                    this.selectionChanged = function selectionChanged(emailAddress) {
                        this.selectedEmails.push(emailAddress);

                        this.callback();
                    };

                    this.getSelectedCount = function getSelectedCount() {
                        return this.selectedEmails.length;
                    };

                    this.clearAll = function clearAll() {
                        this.selectedEmails = [];
                    };

                    this.isSelected = function isSelected(emailAddress) {
                        return (this.selectedEmails.indexOf(emailAddress) >= 0);
                    };

                    this.showModal = function showModal(event) {
                        function MiniModalController() {
                            this.isSelected = function isSelected(emailAddress) {
                                return (this.selectedEmailAddresses.indexOf(emailAddress) >= 0);
                            };

                            this.getSelectedCount = function getSelectedCount() {
                                return this.selectedEmailAddresses.length;
                            };

                            this.updateCount = function updateCount() {
                                this.selectedCount = this.$translate.instant('icm-search__mini-mod__selected-count-label', {count: this.getSelectedCount()});
                            };

                            this.toggle = function toggle(emailAddress) {
                                var index = this.selectedEmailAddresses.indexOf(emailAddress);

                                if (index >= 0) {
                                    this.selectedEmailAddresses.splice(index, 1);
                                } else {
                                    this.selectedEmailAddresses.push(emailAddress);
                                }

                                this.updateCount();
                            };

                            this.clearAll = function clearAll() {
                                this.selectedEmailAddresses = [];
                                this.updateCount();
                            };

                            this.updateCount();
                        }

                        this.$mdDialog.show(
                            this.$mdDialog.mwMiniModal({
                                locals: {
                                    emailAddressList: angular.copy(this.selectedEmails),
                                    selectedEmailAddresses: angular.copy(this.selectedEmails),
                                    selectedCount: this.getSelectedCount(),
                                    filterName: 'icm-search__email-filter-modal--title',
                                    $mdDialog: this.$mdDialog,
                                    $translate: this.$translate
                                },
                                controller: MiniModalController,
                                templateUrl: 'icm-web/views/filter_modals/email_address_mini_modal',
                                controllerAs: '$ctrl'
                            }).targetEvent(event)
                        ).then(
                            function okHandler(selectedEmailAddresses) {
                                _this.selectedEmails = angular.copy(selectedEmailAddresses);
                                _this.callback();
                            }.bind(this)
                        ).catch(function () {});
                    };
                }

                EmailFilter.prototype = Object.create(FilterFactory.prototype);

                return EmailFilter;
            }
        ])
        .factory('ListStatusFilter', [
            'FilterFactory',
            'FilterSelectionFactory',
            function (FilterFactory) {
                function ListStatusFilter(name, triggerSearchFunction) {
                    var _this = this;
                    FilterFactory.call(this, name, triggerSearchFunction);

                    this.selectedOption = null;

                    this.selectionChanged = function selectionChanged(selectedOption) {
                        this.selectedOption = selectedOption;

                        this.callback();
                    };

                    this.getIsFilterSelected = function getIsFilterSelected() {
                        return (this.selectedOption !== null);
                    };

                    this.getSelectedCount = function getSelectedCount() {
                        return ((this.selectedOption === null) ? 0 : 1);
                    };

                    this.getSelectedOption = function getSelectedOption() {
                        return this.selectedOption;
                    };

                    this.clearAll = function clearAll() {
                        this.selectedOption = null;
                    };

                    this.showModal = function showModal(event) {
                        function MiniModalController() {
                            this.getSelectedCount = function getSelectedCount() {
                                return ((this.selectedOption === null) ? 0 : 1);
                            };

                            this.clearAll = function clearAll() {
                                this.selectedOption = null;

                                this.updateCountString(0);
                            };

                            this.updateCountString = function updateCountString(count) {
                                this.selectedCountString = this.$translate.instant('icm-search__mini-mod__selected-count-label', {count: count});
                            };

                            this.updateCountString(this.getSelectedCount());
                        }

                        this.$mdDialog.show(
                            this.$mdDialog.mwMiniModal({
                                locals: {
                                    selectedOption: angular.copy(this.selectedOption),
                                    selectedCountString: this.selectedCountString,
                                    filterName: 'icm-search__list-status-filter-modal--title',
                                    $mdDialog: this.$mdDialog,
                                    $translate: this.$translate
                                },
                                controller: MiniModalController,
                                templateUrl: 'icm-web/views/filter_modals/list_status_mini_modal',
                                controllerAs: '$ctrl'
                            }).targetEvent(event)
                        ).then(
                            function okHandler(selectedOption) {
                                _this.selectedOption = angular.copy(selectedOption);
                                _this.callback();
                            }.bind(this)
                        ).catch(function () {});
                    };
                }

                ListStatusFilter.prototype = Object.create(FilterFactory.prototype);

                return ListStatusFilter;
            }
        ]);
})();